import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const Disclaimer = styled.div`
    padding-top: 16px;

    font-size: 12px;
    line-height: 18px;
    color: ${Colors.Gray.V300};
    text-align: center;

    > .ant-btn.sds-button {
        padding: 0;
        font-size: 12px;
        font-weight: 500;
        vertical-align: baseline;
    }

    > .sds-base-button.ant-btn.link {
        min-height: 12px;
    }
`;
